import type { DiscoveredRouteModule } from '@/router/generator/types';

const NotFoundView = () => import('@/views/error-pages/NotFoundView.vue');
export const NAME_NOT_FOUND = 'NotFound';

export const route: DiscoveredRouteModule = {
  id: 'root.error.not_found',
  scope: 'root',
  name: NAME_NOT_FOUND,
  path: '/not-found',
  component: NotFoundView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true },
};


